import { CommentOrReport } from './model';
import { TypeCodeTranslation } from '../../../business/models/shared.model';

export interface DetailsCommentOrReportState {
  readonly commentsOrReports: CommentOrReport[];
  readonly documentTypeTCValues: TypeCodeTranslation[];
}

export const enum DetailsCommentOrReportActionTypes {
  FETCH_COMMENT_OR_REPORT = '@@detailsCommentOrReport/FETCH_COMMENT_OR_REPORT',
  FETCH_COMMENT_OR_REPORT_FAIL = '@@detailsCommentOrReport/FETCH_COMMENT_OR_REPORT_FAIL',
  FETCH_COMMENT_OR_REPORT_SUCCESS = '@@detailsCommentOrReport/FETCH_COMMENT_OR_REPORT_SUCCESS',
  UPLOAD_COMMENT_OR_REPORT = '@@detailsCommentOrReport/UPLOAD_OTHER_ATTACHMENTS',
  UPLOAD_COMMENT_OR_REPORT_FAIL = '@@detailsCommentOrReport/UPLOAD_COMMENT_OR_REPORT_FAIL',
  UPLOAD_COMMENT_OR_REPORT_SUCCESS = '@@detailsCommentOrReport/UPLOAD_COMMENT_OR_REPORT_SUCCESS',
  DELETE_COMMENT_OR_REPORT = '@@detailsCommentOrReport/DELETE_COMMENT_OR_REPORT',
  DELETE_COMMENT_OR_REPORT_FAIL = '@@detailsCommentOrReport/DELETE_COMMENT_OR_REPORT_FAIL',
  DELETE_COMMENT_OR_REPORT_SUCCESS = '@@detailsCommentOrReport/DELETE_COMMENT_OR_REPORT_SUCCESS',
  RESET_STATE = '@@detailsCommentOrReport/RESET_STATE',
  SET_COMMENT_OR_REPORT_REQUEST_STATE = '@@detailsCommentOrReport/SET_COMMENT_OR_REPORT_REQUEST_STATE',
  RESET_UPLOADED_ITEMS_INDEXES = '@@detailsCommentOrReport/RESET_UPLOADED_ITEMS_INDEXES',
  ADD_COMMENT_OR_REPORT = '@@detailsCommentOrReport/ADD_COMMENT_OR_REPORT',
  UPDATE_REPORT_STATUS_TC = '@@detailsCommentOrReport/UPDATE_REPORT_STATUS_TC',
  UPDATE_SUBJECT = '@@detailsCommentOrReport/UPDATE_SUBJECT',
  UPDATE_DESCRIPTION = '@@detailsCommentOrReport/UPDATE_DESCRIPTION',
  FETCH_DOCUMENT_TYPES = '@@detailsCommentOrReport/FETCH_DOCUMENT_TYPES',
  FETCH_DOCUMENT_TYPES_SUCCESS = '@@detailsCommentOrReport/FETCH_DOCUMENT_TYPES_SUCCESS',
  FETCH_DOCUMENT_TYPES_FAIL = '@@detailsCommentOrReport/FETCH_DOCUMENT_TYPES_FAIL',
  ATTACH_FILE = '@@detailsCommentOrReport/ATTACH_FILES'
}
